;(() => {
  class PdpStickyAtc extends XThemeBaseElement {
    mount() {
      this.button = this.querySelector('[data-sticky-atc-button]')
      this._titleEl = this.querySelector('[data-sticky-product-title]')
      this._variantTitleEl = this.querySelector('[data-sticky-variant-title]')
      this._priceEl = this.querySelector('[data-sticky-price]')
      this._imageEl = this.querySelector('.pdp-sticky-atc__image')

      if (!this.button) return

      this._onStickyButtonClick = this._onStickyButtonClick.bind(this)
      this._onVariantChange = this._onVariantChange.bind(this)
      this._syncMainButton = this._syncMainButton.bind(this)
      this._hasVariantEvent = false
      this._lastMarkupVariantKey = ''

      this.button.addEventListener('click', this._onStickyButtonClick, { signal: this._ac.signal })
      document.addEventListener('variant:change', this._onVariantChange, { signal: this._ac.signal })

      const jquery = window.jQuery_T4NT || window.jQuery
      if (typeof jquery === 'function') {
        this._jquery = jquery
        this._jquery(document).on('variant:change.pdpStickyAtc', this._onVariantChange)
      }

      this._mainSection = this._findMainSection()
      this._markupObserver = new MutationObserver(() => {
        this._syncMainButton()
        this._syncVariantFromMarkup()
      })

      if (this._mainSection) {
        this._markupObserver.observe(this._mainSection, { childList: true, subtree: true })
      }

      this._intersectionObserver = new IntersectionObserver(
        ([entry]) => this._setVisible(!entry.isIntersecting),
        { threshold: 0 },
      )

      this._syncMainButton()
      this._syncVariantFromMarkup()
      this._observeMainButton()
    }

    unmount() {
      this._intersectionObserver?.disconnect()
      this._markupObserver?.disconnect()
      if (this._jquery) {
        this._jquery(document).off('variant:change.pdpStickyAtc', this._onVariantChange)
      }
    }

    _findMainSection() {
      return (
        document.querySelector('.product-infors')?.closest('.shopify-section') ||
        document.querySelector('#shopify-section-main-product')
      )
    }

    _findMainButton() {
      return document.querySelector('.product-infors .js_frm_cart, .product-infors .out_stock')
    }

    _observeMainButton() {
      const mainButton = this._findMainButton()
      if (mainButton === this._mainButton) return

      this._intersectionObserver.disconnect()
      this._mainButton = mainButton

      if (mainButton) {
        this._intersectionObserver.observe(mainButton)
      } else {
        this._setVisible(false)
      }
    }

    _syncMainButton() {
      this._observeMainButton()
      const mainButton = this._mainButton

      if (!mainButton) {
        this.button.disabled = true
        return
      }

      const buttonStyles = window.getComputedStyle(mainButton)
      const isHidden = buttonStyles.display === 'none' || buttonStyles.visibility === 'hidden'
      const isUnavailable = mainButton.classList.contains('out_stock')
      this.button.disabled =
        isHidden || isUnavailable || mainButton.disabled || mainButton.classList.contains('disabled')

      const label = [...mainButton.querySelectorAll('.txt_add, .txt_pre')].find((item) => {
        const styles = window.getComputedStyle(item)
        return !item.hidden && styles.display !== 'none' && styles.visibility !== 'hidden'
      })

      const text = label?.textContent?.trim() || mainButton.textContent.trim()
      if (text) this.button.textContent = text
    }

    _setVisible(visible) {
      this.classList.toggle('is-visible', visible)
      this.setAttribute('aria-hidden', String(!visible))
    }

    _onStickyButtonClick() {
      const mainButton = this._findMainButton()
      if (!mainButton) return

      mainButton.click()
    }

    _onVariantChange(event) {
      const variant = event?.detail || arguments[1]
      if (variant && typeof variant === 'object') {
        this._hasVariantEvent = true
        this._renderVariant(variant)
      }
      this._syncMainButton()
    }

    _syncVariantFromMarkup() {
      const source = this._mainSection?.querySelector('[data-sticky-product-title]')
      if (source) {
        const markupVariantKey = [
          source.dataset.stickyProductTitle,
          source.dataset.stickyVariantTitle,
          source.dataset.stickyPrice,
          source.dataset.stickyComparePrice,
          source.dataset.stickyImage,
        ].join('|')

        if (markupVariantKey === this._lastMarkupVariantKey) {
          this._syncMainButton()
          return
        }

        this._lastMarkupVariantKey = markupVariantKey
        this._renderVariant({
          product_title: source.dataset.stickyProductTitle,
          title: source.dataset.stickyVariantTitle,
          price: Number(source.dataset.stickyPrice),
          compare_at_price: Number(source.dataset.stickyComparePrice),
          featured_image: source.dataset.stickyImage
            ? { src: source.dataset.stickyImage }
            : null,
        })
        return
      }

      if (!this._hasVariantEvent) {
        const selectedVariant = document.querySelector(
          '#shopify-section-main-product [data-selected-variant]',
        )

        if (selectedVariant?.textContent?.trim()) {
          try {
            this._renderVariant(JSON.parse(selectedVariant.textContent))
          } catch (error) {
            // The main product markup may be mid-replacement.
          }
        }
      }

      this._syncMainButton()
    }

    _renderVariant(variant) {
      const title = variant.title || ''
      const hasVariantTitle = title && title !== 'Default Title'

      if (this._titleEl && variant.product_title) {
        this._titleEl.textContent = variant.product_title
      }

      if (this._variantTitleEl) {
        this._variantTitleEl.textContent = hasVariantTitle ? title : ''
        this._variantTitleEl.hidden = !hasVariantTitle
      }

      if (this._priceEl && typeof variant.price === 'number') {
        const price = this._formatMoney(variant.price)
        const comparePrice = Number(variant.compare_at_price)

        this._priceEl.innerHTML =
          comparePrice > variant.price
            ? `<del>${this._formatMoney(comparePrice)}</del><ins>${price}</ins>`
            : price
      }

      const imageUrl = variant.featured_image?.src || variant.featured_media?.preview_image?.src
      if (this._imageEl && imageUrl) {
        this._imageEl.src = imageUrl
      }

      this._syncMainButton()
    }

    _formatMoney(value) {
      if (typeof window.geckoShopify?.formatMoney === 'function') {
        return window.geckoShopify.formatMoney(value)
      }

      return `$${(Number(value) / 100).toFixed(2)}`
    }
  }

  if (!window.customElements.get('x-pdp-sticky-atc')) {
    window.customElements.define('x-pdp-sticky-atc', PdpStickyAtc)
  }
})()
